import axios from 'axios'
import { config } from 'src/constants/config'
import { setupAuthInterceptor } from './interceptors/authInterceptor'
import { setupErrorInterceptor } from './interceptors/errorInterceptor'

let reduxStore = null

export const injectStore = (store) => {
  if (!reduxStore) reduxStore = store
}

export const httpClient = axios.create({
  baseURL: config.restURL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Register interceptors
setupAuthInterceptor(httpClient)
setupErrorInterceptor(httpClient)
